module.exports = __webpack_public_path__ + "1_rodapenov_.png?2d4e8c8e4015881b33f8d56fa5ef7439";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/1_rodapenov_.png
// module id = 115
// module chunks = 0